import Container from "@mui/material/Container";
import Grid from '@mui/material/Unstable_Grid2';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import useModal from '../../hooks/use-modal';

import { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { userDetailStyle } from '../../styles/pages/user/user-detail';
import { useQueryUserDetail, useMutationUserVerification, useQueryUserRoleList } from '../../api/user';
import { UserDetailById, UserRoleList } from '../../types/user';


export function EditUserDetail(){
  const { id } = useParams();
  const { showModal } = useModal();
  const navigate = useNavigate();

  const [dataRole, setDataRole] = useState<UserRoleList[]>([])

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [personCode, setPersonCode] = useState('')
  const [address, setAddress] = useState('')
  const [status, setStatus] = useState('')
  const [role, setRole] = useState('')
  const [institution, setInstitution] = useState('')
  const [faculty, setFaculty] = useState('')
  const [studyProgram, setStudyProgram] = useState('')
  const [academicCareer, setAcademicCareer] = useState('')
  const [userDetail, setUserDetail] = useState<UserDetailById | null>(null);

  const getUserRoleList = useQueryUserRoleList({
    options: {
      onSuccess: (res) => {
        setDataRole(res.data)
      },
      onError: () => {
        setDataRole([])
      }
    },
  });

  const getUserDetail = useQueryUserDetail({
    query: {
      userId: `${id}`,
    },
    options: {
      onSuccess: (res) => {
        setUserDetail(res.data);
        setName(res.data.fullName);
        setEmail(res.data.email);
        setPersonCode(res.data.personCode)
        setAddress(res.data.address)
        setStatus(res.data.status);
        setRole(res.data.roleId);
        setInstitution(res.data.institution);
        setFaculty(res.data.faculty);
        setStudyProgram(res.data.studyProgram);
        setAcademicCareer(res.data.academicCareer);
      },
      onError: () => {
        setUserDetail(null);
        setName('');
        setEmail('');
        setPersonCode('');
        setAddress('');
        setStatus('');
        setRole('');
        setInstitution('');
        setFaculty('');
        setStudyProgram('');
        setAcademicCareer('');
      }
    },
  });

  const userVerification  = useMutationUserVerification({
    onSuccess: async (res) => {
      showModal({
        title: 'Success',
        message:
          'Update user successfully.',
        options: {
          variant: 'success',
          onOk: () => {
            navigate(`/user-detail/${id}`)
          }
        },
      });
    },
    onError: (error) => {
      showModal({
        title: 'Error',
        message:
          'Update user is failed.',
        options: {
          variant: 'failed',
        },
      });
    },
  });

  const doUserVerification = () => {
    userVerification.mutate({
      UserId: id !== undefined ? id : "",
      RoleId: role,
      Status: status
    })
  }

  return( 
    <Container maxWidth={false} sx={userDetailStyle.contentContainer}>
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/user">
              User
            </Link>
            <Link underline="hover" color="inherit" onClick={() => navigate(`/user-detail/${id}`)}>
              User Detail
            </Link>
            <Link
              underline="hover"
              color="text.primary"
              onClick={() => navigate('/user-detail/1/edit')}
              aria-current="page"
            >
              Edit
            </Link>
          </Breadcrumbs>
        </Grid>
        <Grid xs={12}>
          <Box sx={userDetailStyle.contentContainerGridItem1Box}>
            <Typography variant="h3" sx={userDetailStyle.contentTypography}>User Detail</Typography>
            <Box>
              <Button variant="contained" color="error" sx={userDetailStyle.contentContainerGridItem1BoxBox} onClick={() => navigate(`/user-detail/${id}`)}>Cancel</Button>
              <Button variant="contained" color="success" onClick={doUserVerification}>Submit</Button>
            </Box>
          </Box>
        </Grid>
        <Grid xs={12}>
          <Paper elevation={3} sx={userDetailStyle.contentContainerGridItem2Paper}>
            <Grid container spacing={2}>
              <Grid xs={3}>
                <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>Personal Information</Typography>
              </Grid>
              <Grid container spacing={2} xs>
                <Grid xs={12}>
                  <Box
                    component="img"
                    src={userDetail?.avatar}
                    alt="user-avatar"
                    sx={userDetailStyle.contentContainerGridItem2PaperGridItemItemBox}
                  />
                </Grid>
                <Grid xs={2}>
                  <Typography>Full Name</Typography>
                </Grid>
                <Grid xs={10}>
                  <TextField id="fullname" label="Full Name" variant="outlined" size="small" fullWidth value={name} onChange={(e) => setName(e.target.value)} disabled/>
                </Grid>
                <Grid xs={2}>
                  <Typography>Email</Typography>
                </Grid>
                <Grid xs={10}>
                  <TextField id="email" label="Email Address" variant="outlined" size="small" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} disabled/>
                </Grid>
                <Grid xs={2}>
                  <Typography>Person Code</Typography>
                </Grid>
                <Grid xs={10}>
                  <TextField id="person-code" label="Person Code" variant="outlined" size="small" fullWidth value={personCode} onChange={(e) => setPersonCode(e.target.value)} disabled/>
                </Grid>
              </Grid>
              <Grid xs={12}>
                <Divider/>
              </Grid>
              <Grid xs={3}>
                <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>Apps Information</Typography>
              </Grid>
              <Grid container spacing={2} xs>
                <Grid xs={2}>
                  <Typography>Status</Typography>
                </Grid>
                <Grid xs={10}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="status-select-label">Status</InputLabel>
                    <Select 
                      labelId="status-select-label"
                      id="status-select"
                      value={status}
                      label="Status"
                      onChange={(e) => setStatus(e.target.value)}
                      fullWidth
                      >
                        <MenuItem value="Verified">Verified</MenuItem>
                        <MenuItem value="Unverified">Unverified</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid xs={2}>
                  <Typography>Role</Typography>
                </Grid>
                <Grid xs={10}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="role-select-label">Role</InputLabel>
                    <Select 
                      labelId="role-select-label"
                      id="role-select"
                      value={role}
                      label="Role"
                      onChange={(e) => setRole(e.target.value)}
                      fullWidth
                      >
                        {dataRole.map(item => (
                          <MenuItem value={item.roleId}>{item.roleName}</MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid xs={12}>
                <Divider/>
              </Grid>
              <Grid xs={3}>
                <Typography variant="subtitle1" sx={userDetailStyle.contentTypography}>Academic Information</Typography>
              </Grid>
              <Grid container spacing={2} xs>
                <Grid xs={2}>
                  <Typography>Institution</Typography>
                </Grid>
                <Grid xs={10}>
                  <TextField id="institution" label="Institution" variant="outlined" size="small" fullWidth value={institution} onChange={(e) => setInstitution(e.target.value)} disabled/>
                </Grid>
                <Grid xs={2}>
                  <Typography>Faculty</Typography>
                </Grid>
                <Grid xs={10}>
                  <TextField id="faculty" label="Faculty" variant="outlined" size="small" fullWidth value={faculty} onChange={(e) => setFaculty(e.target.value)} disabled/>
                </Grid>
                <Grid xs={2}>
                  <Typography>Study Program</Typography>
                </Grid>
                <Grid xs={10}>
                  <TextField id="study-program" label="Study Program" variant="outlined" size="small" fullWidth value={studyProgram} onChange={(e) => setStudyProgram(e.target.value)} disabled/>
                </Grid>
                <Grid xs={2}>
                  <Typography>Academic Career</Typography>
                </Grid>
                <Grid xs={10}>
                  <TextField id="academic-career" label="Academic Career" variant="outlined" size="small" fullWidth value={academicCareer} onChange={(e) => setAcademicCareer(e.target.value)} disabled/>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  )
}